module.exports = __webpack_public_path__ + "img/logo_bridge.be8e50f2.png";